<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-4">
        <div class="d-flex justify-content-end mb-2">
          <b-button
              class="align-items-right"
              variant="outline-primary"
              v-on:click="abrirModal()">
            Agregar Tutor
          </b-button>
        </div>

        <div v-if="edicionLinkUsuario">
          <BusquedaNombreTutores v-if="headers" :headers="headers" :nombreTutor="infoPaciente.tutor.nombreTutor" @setearPaciente="setearPaciente" @limpiarPacienteSeleccionado="limpiarPacienteSeleccionado"/>
        </div>
        <div v-else>
          <BusquedaNombreTutores :nombreTutor="infoPaciente.tutor.nombreTutor" @setearPaciente="setearPaciente" @limpiarPacienteSeleccionado="limpiarPacienteSeleccionado"/>
        </div>

     
    </div>

    <div class="m-4">
      <p v-if="infoPaciente.tutor.idPacienteTutor == null" class="text-center">Selecciona un Tutor para poder llenar los siguientes campos.</p>
    </div>

    <b-row class="mt-4 mb-4">
      <b-col sm="12" md="6" lg="2" xl="2">
        <label>Parentesco:</label>
        <b-form-select
            text-field="nombre"
            :options="listaParentesco"
            value-field="idParentesco"
            v-model="infoPaciente.tutor.idParentesco"
            placeholder="Selecciona una opción"
            :state="
                infoPaciente.tutor.idParentesco !== null
              "
            :required="infoPaciente.tutor.idPacienteTutor != null"
        ></b-form-select>
        <b-form-invalid-feedback
            :state="
                (infoPaciente.tutor.idPacienteTutor != null && infoPaciente.tutor.idParentesco != null) ||
                infoPaciente.tutor.idPacienteTutor == null
              "
        >
          Se debe seleccionar un parentesco con el familiar
        </b-form-invalid-feedback>
      </b-col>
      <b-col sm="12" md="6" lg="6" xl="6">
        <label>Dirección:</label>
        <b-form-input
            type="text"
            v-model="infoPaciente.tutor.domicilio"
            placeholder="Dirección:"
            disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Correo: </label>
        <b-form-input
            onpaste="return false;"
            type="email"
            v-model="infoPaciente.tutor.correo"
            placeholder="Correo:"
            :disabled="infoPaciente.tutor.idPersona == null || existeCorreo"
        >
        </b-form-input>
      </b-col>


    </b-row>

    <b-row class="mt-4 mb-4">
      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Teléfono Celular:</label>
        <VuePhoneNumberInput
            onpaste="return false;"
            maxlength="12" oninput="if(this.value.replace(' ').length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            v-model="infoPaciente.tutor.telefono"
            default-country-code="MX"
            :translations="traslationsTxt"
            placeholder="Ingresa número a 10 dígitos:"
            :disabled="infoPaciente.tutor.idPersona == null || existeTelefono"
        />
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Empresa en la que trabaja</label>
        <b-form-input
            v-model="infoPaciente.tutor.empresaTrabajo"
            placeholder="empresa"
            type="text"
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Puesto que desempeña</label>
        <b-form-input
            v-model="infoPaciente.tutor.puestoDesempenio"
            placeholder="puesto"
            type="text"
        >
        </b-form-input>
      </b-col>


    </b-row>




    

    <b-modal
        size="xl"
        ref="altaTutor"
        title="Alta de tutor"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        no-fade
    >
      <b-container fluid>
        <alta-paciente
            :historiaNino="historiaNino"
            :ninoLinkProp="ninoLinkProp"
        />
      </b-container>
    </b-modal>

  </div>
</template>
 
<script>
import AltaPaciente from "@/components/paciente/AltaPaciente";
import VuePhoneNumberInput from "vue-phone-number-input";
import BusquedaNombreTutores from "@/components/paciente/tutores/BusquedaNombreTutores.vue";
import "vue-phone-number-input/dist/vue-phone-number-input.css";


export default {
  name: "DatosPadreHistoriaNino",
  components: {
    AltaPaciente,
    VuePhoneNumberInput,
    BusquedaNombreTutores
  },
  props: {
    headers: Object,
    infoPaciente: Object,
    listaCercania: Array,
    listaEnterarse: Array,
    cargandoCercania: Boolean,
    cargandoMedio: Boolean,
    listaParentesco: Array,
    paciente: String,
    ninoLinkProp: Boolean,
    urlBase: String,
    existeCorreo: Boolean,
    existeTelefono: Boolean,
    existeCasa: Boolean,
    existeTrabajo: Boolean,
    idPaciente: String,
    edicionLinkUsuario: Boolean
  },
  created(){
    this.debug = this.$localStorageService.getDebug();   
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    traslationsTxt: {
      countrySelectorLabel: "Código de país",
      countrySelectorError: "Elige un país",
      /* phoneNumberLabel: "Número de teléfono de 10 dígitos", */
      example: "Ejemplo :",
    },
    encabezados: [{
      key: "name",
      label: "Nombre del Paciente"
    },
      {
        key: "nacimiento",
        label: "Fecha de nacimiento"
      },
    ],
    listaBusquedaPaciente: [],
    listaPacientes: [],
    paginaActual: 1,
    registrosPorPagina: 15,
    loadingPacientes: false,
    nombrePacienteBusqueda: "",
    historiaNino: true,
  }),
  computed: {
    mostrarBusquedaPaciente: function () {
      return this.infoPaciente.tutor.idPacienteTutor === undefined || this.infoPaciente.tutor.idPacienteTutor < 1;
    },
  },
methods: {
  limpiarPacienteSeleccionado()
  {
    this.infoPaciente.tutor.idPacienteTutor = null;
    this.infoPaciente.tutor.nombreTutor = null;
    this.infoPaciente.tutor.idParentesco = null;
    this.nombrePacienteBusqueda = null;
    this.listaPacientes = Array();
    this.infoPaciente.tutor.idPersona = null;
    this.infoPaciente.tutor.domicilio = null;
    this.infoPaciente.tutor.correo = null;
    this.infoPaciente.tutor.telefono = null;
    this.infoPaciente.tutor.casa = null;
    this.infoPaciente.tutor.trabajo = null;
    this.existeCorreo = false;
    this.existeCasa = false;
    this.existeTelefono = false;
    this.existeTrabajo = false;
  }
,

  setearPaciente(item)
  {
    if(item.id.toString() ===  this.idPaciente){
      this.$swal({
        icon: "warning",
        text: "El paciente no puede ser su propio tutor.",
        confirmButtonText: "OK",
        confirmButtonColor: "#0e6ba9",
      });
      return false;

    }
    this.validarExisteDatoTutor(item);
    this.infoPaciente.tutor.idPacienteTutor = item.id;
    this.infoPaciente.tutor.nombreTutor = item.name;
    this.infoPaciente.tutor.idPersona = item.idPersona;
    this.infoPaciente.tutor.correo = item.correo;
    if(item.telefono.localeCompare("null") == 0){
      this.infoPaciente.tutor.telefono = "";
    }else{
      this.infoPaciente.tutor.telefono = item.telefono;
    }
    if(item.telefonoCasa.localeCompare("null") == 0){
      this.infoPaciente.tutor.casa = "";
    }else{
      this.infoPaciente.tutor.casa = item.telefonoCasa;
    }
    if(item.telefonoTrabajo.localeCompare("null") == 0){
      this.infoPaciente.tutor.trabajo = "";
    }else{
      this.infoPaciente.tutor.trabajo = item.telefonoTrabajo;
    }
    this.infoPaciente.tutor.sobrenombre = item.sobrenombre;
    this.infoPaciente.tutor.facebook = item.facebook;
    this.infoPaciente.tutor.twitter = item.twitter;
    if(item.calle == null && item.colonia == null && item.cp == null){
      this.infoPaciente.tutor.domicilio = "No ha registrado un domicilio"
    } else {
      this.infoPaciente.tutor.domicilio = item.calle + ', ' + item.colonia + ', ' + item.cp;
    }
  },
  validarExisteDatoTutor(item){
    if(item.correo !== null && item.correo !== ""){
      this.existeCorreo = true;
    }
    if(item.telefono !== null && item.telefono !== ""){
      if(item.telefono.replace(/ /g, "").length === 10){
        this.existeTelefono = true;
      }
    }
    if(item.telefonoCasa !== null && item.telefonoCasa !== ""){
      if(item.telefonoCasa.replace(/ /g, "").length === 10){
        this.existeCasa = true;
      }
    }
    if(item.telefonoTrabajo !== null && item.telefonoTrabajo !== ""){
      if(item.telefonoTrabajo.replace(/ /g, "").length === 10){
        this.existeTrabajo = true;
      }
    }
  },
  limpiarCercania()
  {
    this.infoPaciente.historia.cercaniaOtro = "";
  }
,

  abrirModal()
  {
    this.$refs["altaTutor"].show();
  }
,
}
}
</script>

<style scoped>
 label {
        color: #0046a2 !important;
  }
  p {
        color: #0046a2 !important;
  }
</style>
